/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { ChromePicker, CirclePicker, ColorChangeHandler } from 'react-color';
import Tooltip from '../../styled/Tooltip/Tooltip';

import {
  ColorPickerWrapper,
  ColorPickerPopover,
} from './TemplateConfig.styles';

interface ColorPickerProps {
  color: string;
  label: string;
  onChange: ColorChangeHandler;
}

const TIPPY_ACTIVE_CLASS = 'tippy-active';
const ColorPicker: React.FC<ColorPickerProps> = ({
  color,
  label,
  onChange,
}) => {
  const handleTippyOpen = () => {
    document.body.classList.add(TIPPY_ACTIVE_CLASS);
  };
  const handleTippyClose = () => {
    document.body.classList.remove(TIPPY_ACTIVE_CLASS);
  };
  return (
    <Tooltip
      content={
        <ColorPickerPopover>
          <ChromePicker color={color} onChange={onChange} disableAlpha />
          <CirclePicker
            colors={[
              '#f44336',
              '#e91e63',
              '#9c27b0',
              '#673ab7',
              '#8bc34a',
              '#cddc39',
              '#ffeb3b',
              '#ffc107',
              '#ff9800',
              '#ff5722',
            ]}
            width="220px"
            onChange={onChange}
            color={color}
          />
        </ColorPickerPopover>
      }
      trigger="click"
      interactive
      placement="bottom-end"
      onShow={handleTippyOpen}
      onClickOutside={handleTippyClose}
      className="tippy-color-picker"
    >
      <ColorPickerWrapper>
        <p className="label">{label}</p>
        <span className="color" style={{ background: color }} />
      </ColorPickerWrapper>
    </Tooltip>
  );
};

export default React.memo(ColorPicker);
